module.exports = __webpack_public_path__ + "static/media/contactUSVN.801359ed.png";